export const buildAlbumsExportCsv = (albums = []) => {
  const headers = ['Album Name', 'Record Label', 'Song Count', 'Created At'];
  const rows = albums.map((album) => [
    album.name || '—',
    album.recordLabelName || album.record_label_name || '—',
    album.songCount || album.song_count || 0,
    album.created_at ? String(album.created_at).split('T')[0] : '—'
  ]);

  const csvContent = [
    headers.join(','),
    ...rows.map((row) => row.map((val) => `"${String(val).replace(/"/g, '""')}"`).join(','))
  ].join('\n');

  return csvContent;
};

export const downloadCsv = (csvContent, filename) => {
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const downloadUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', downloadUrl);
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(downloadUrl);
};
